import { FC, useEffect, useState } from "react";
import { useApi } from "../../../api/use-api";
import { storageList } from "../../../api/storage/storage";
import {
  Box,
  TextField,
  Paper,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Theme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Button } from "../../../components/button/button";
import useScreenSize from "../../../utils/use-screen";
import * as Yup from "yup";
import { useFormik } from "formik";
import { makeStyles } from "@mui/styles";

const CELLS = [
  "id",
  "UId",
  "name",
  "type",
  "address",
  "ext",
  "userName",
  "createdAt",
  "deletedAt",
];

export const Files: FC = () => {
  const { api: storageListApi, data: files, loading } = useApi(storageList);
  const { isDesktop } = useScreenSize();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(15);
  const classes = useClass();

  const { values, errors, handleSubmit, handleChange, setFieldValue } =
    useFormik({
      validationSchema: Yup.object({
        accountId: Yup.string(),
      }),
      initialValues: {
        accountId: "",
      },
      onSubmit: (data) => {
        storageListApi({
          skip: page * limit,
          limit: limit,
          ...data,
        });
      },
    });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accountId = urlParams.get("accountId");
    storageListApi({
      skip: 0,
      limit: 15,
      ...(accountId ? { accountId } : {}),
    });
    if (accountId) {
      setFieldValue("accountId", accountId);
    }
  }, [storageListApi, setFieldValue]);

  return (
    <Box
      overflow={"none"}
      display="flex"
      flexDirection="column"
      maxWidth={"100%"}
    >
      <Box component="form" m={1} onSubmit={handleSubmit}>
        <TextField
          size="small"
          id="accountId"
          name="accountId"
          placeholder="accountId"
          value={values.accountId}
          error={!!errors.accountId}
          onChange={handleChange}
          className={classes.inputs}
        />
        <Button
          variant="outlined"
          type="submit"
          loading={loading}
          disabled={loading}
        >
          submit
        </Button>
      </Box>
      <Paper
        component={Grid}
        width={isDesktop ? "80vw" : "100vw"}
        overflow={"scroll"}
      >
        <TableContainer sx={{ width: "100%", overflowX: "scroll" }}>
          <Table aria-labelledby="tableTitle" size={"small"}>
            <TableHead>
              <TableRow>
                {CELLS.map((item) => (
                  <TableCell key={item}>{item}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {files?.list.map((item) => {
                return (
                  <TableRow key={item.id}>
                    <TableCell>{item.id.slice(-8)}</TableCell>
                    <TableCell>
                      <Link to={"/app/users/?accountId=" + item.createBy.id}>
                        {item.createBy.id.slice(-8)}
                      </Link>
                    </TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.type}</TableCell>
                    <TableCell>{item.address}</TableCell>
                    <TableCell>{item.ext}</TableCell>
                    <TableCell>
                      {item.createBy.firstName + " " + item.createBy.lastName}
                    </TableCell>
                    <TableCell>{item.createdAt}</TableCell>
                    <TableCell>{item.deletedAt}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          rowsPerPageOptions={[15, 30, 60, 100, 200, 500, 1000]}
          count={files?.count || 0}
          rowsPerPage={limit}
          page={page}
          onPageChange={(_, page) => {
            storageListApi({
              skip: page * limit,
              limit: limit,
              accountId: values.accountId || "",
            });
            setPage(page);
          }}
          onRowsPerPageChange={(e) => {
            setLimit(parseInt(e.target.value));
            storageListApi({
              skip: page * parseInt(e.target.value),
              limit: parseInt(e.target.value),
              accountId: values.accountId || "",
            });
          }}
        />
      </Paper>
    </Box>
  );
};

const useClass = makeStyles((theme: Theme) => ({
  inputs: {
    margin: `${theme.spacing(0, 0.5)} !important`,
  },
}));
